<template>
    <el-dialog :title="title" :close-on-click-modal="false" :visible.sync="visible" width="1000px">
        <table style="margin-left:0px;">
            <tr>
                <td class="ttd">
                    <label slot="label">
                        <span>标的物</span>
                    </label>
                </td>
                <td colspan="2">
                    <el-row>
                        <span class="set_data">{{ dataForm.subjectName }}</span>
                    </el-row>
                </td>
                <td class="ttd">
                    <label slot="label">
                        <span>专业</span>
                    </label>
                </td>
                <td colspan="3">
                    <el-row>
                        <span class="set_data">{{ dataForm.majorName }}</span>
                    </el-row>
                </td>
            </tr>
            <tr>
                <td class="ttd">
                    <label slot="label">
                        <span>检验人</span>
                    </label>
                </td>
                <td colspan="2">
                    <el-row>
                        <span class="set_data">{{ dataForm.testMan }}</span>
                    </el-row>
                </td>
                <td class="ttd">
                    <label slot="label">
                        <span>检验时间</span>
                    </label>
                </td>
                <td colspan="3">
                    <el-row>
                        <span class="set_data">{{ dataForm.testDate | formatDate('yyyy-MM-dd') }}</span>
                    </el-row>
                </td>
            </tr>
            <tr>
                <td class="ttd">
                    <label slot="label">
                        <span>检验结论</span>
                    </label>
                </td>
                <td class="ttd test-result-header">
                    <label slot="label">
                        <span>1次检验</span>
                    </label>
                </td>
                <td class="test-result-data">
                    <el-row>
                        <span class="set_data">{{ dataForm.testConclusionName }}</span>
                    </el-row>
                </td>
                <td class="ttd test-result-header">
                    <label slot="label">
                        <span>2次检验</span>
                    </label>
                </td>
                <td class="test-result-data">
                    <el-row>
                        <span class="set_data">{{ dataForm.testConclusionName2 }}</span>
                    </el-row>
                </td>
                <td class="ttd test-result-header">
                    <label slot="label">
                        <span>2次以上检验</span>
                    </label>
                </td>
                <td class="test-result-data">
                    <el-row>
                        <span class="set_data">{{ dataForm.testConclusionName3 }}</span>
                    </el-row>
                </td>
            </tr>
            <tr>
                <td class="ttd">
                    <label slot="label">
                        <span>检验项目</span>
                    </label>
                </td>
                <td colspan="6">
                    <el-row>
                        <span class="set_data">{{ dataForm.probContext }}</span>
                    </el-row>
                </td>
            </tr>
            <tr>
                <td class="ttd">
                    <label slot="label">
                        <span>检验意见</span>
                    </label>
                </td>
                <td colspan="6">
                    <el-row>
                        <span class="set_data" style="text-align: left !important;">{{ dataForm.sutContent }}</span>
                    </el-row>
                </td>
            </tr>
            <tr>
                <td class="ttd">
                    <label slot="label">
                        <span>封闭时间</span>
                    </label>
                </td>
                <td colspan="2">
                    <el-row>
                        <el-date-picker v-model="dataForm.closeTime" type="date" value-format="yyyy-MM-dd"
                            placeholder="选择日期" :clearable="false" class="no-border-input">
                        </el-date-picker>
                    </el-row>
                </td>
                <td class="ttd">
                    <label slot="label">
                        <span>封闭人</span>
                    </label>
                </td>
                <td colspan="3">
                    <el-row>
                        <el-input v-model="dataForm.closeMan" class="no-border-input"></el-input>
                    </el-row>
                </td>
            </tr>
            <tr>
                <td class="ttd">
                    <label slot="label">
                        <span>封闭时状况描述</span>
                    </label>
                </td>
                <td colspan="6">
                    <el-row>
                        <el-input type="textarea" :autosize="{ minRows: 2, maxRows: 10 }"
                            v-model="dataForm.closeDescribe" class="no-border-input">
                        </el-input>
                    </el-row>
                </td>
            </tr>
            <tr>
                <td class="ttd">
                    <label slot="label">
                        <span>备注</span>
                    </label>
                </td>
                <td colspan="6">
                    <el-row>
                        <el-input type="textarea" :autosize="{ minRows: 2, maxRows: 10 }" v-model="dataForm.remark"
                            class="no-border-input">
                        </el-input>
                    </el-row>
                </td>
            </tr>
        </table>

        <el-row>
            <el-col :span="24" class="row-form-item">
                <div class="fileItem">报验照片（如有时）</div>
            </el-col>
        </el-row>
        <el-row style="margin-top: 20px;">
            <!-- <el-col :span="8">
                    <el-upload ref="uploadImg" class="upload-demo" action="action" drag :http-request="uploadImg"
                        multiple :show-file-list=false :auto-upload="true" accept="image/jpeg,image/png,image/jpg"
                        :data="{ 'type': '0' }">
                        <i class="el-icon-upload"></i>
                        <div class="el-upload__text">将图片拖到此处，或<em>点击上传</em></div>
                    </el-upload>
                </el-col> -->
            <el-col :span="24">
                <div class="addImgBox" v-for="(item, index) in dataForm.scenePhotoList"
                    style="margin-top: 5px;margin-bottom: 10px;">
                    <el-image style="width: 100%; height: 100%" :src="item.fileUri" fit="cover"></el-image>
                </div>
                <div v-if="!dataForm.scenePhotoList || dataForm.scenePhotoList.length === 0" style="margin-left: 20px;">
                </div>
            </el-col>
        </el-row>
        <el-row>

            <el-row>
                <el-col :span="24" class="row-form-item">
                    <div class="fileItem">封闭时照片（如有时）</div>
                </el-col>
            </el-row>
            <!-- <el-row style="margin-top: 20px;">
                <el-col :span="8">
                    <el-upload ref="uploadImg" class="upload-demo" action="action" drag :http-request="uploadImg"
                        multiple :show-file-list=false :auto-upload="true" accept="image/jpeg,image/png,image/jpg"
                        :data="{ 'type': '1' }">
                        <i class="el-icon-upload"></i>
                        <div class="el-upload__text">将图片拖到此处，或<em>点击上传</em></div>
                    </el-upload>
                </el-col>
                <el-col :span="16">
                    <div class="addImgBox" v-for="(item, index) in dataForm.closePhotoList"
                        style="margin-bottom: 10px;">
                        <el-image style="width: 100%; height: 100%" :src="item.fileUri" fit="cover"></el-image>
                        <div class="delBox">
                            <i class="el-icon-delete" @click="delClosePhoto(index)"></i>
                        </div>
                    </div>
                </el-col>
            </el-row> -->
            <el-row>
                <el-col :span="24" style="margin-top: 10px;">
                    <el-upload ref="uploadImg" class="upload-demo-photo" action="action" drag :http-request="uploadImg"
                        multiple :show-file-list=false :auto-upload="true" accept="image/jpeg,image/png,image/jpg"  :before-upload="beforeUploadSituation">
                        <i class="el-icon-upload"></i>
                        <div class="el-upload__text">将图片拖到此处，或<em>点击上传</em></div>
                    </el-upload>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="24" style="margin-top: 30px;margin-bottom: 10px;">
                    <el-table class="dataListTable" border header-align="center"
                        v-if="dataForm.closePhotoList.length > 0" :data="dataForm.closePhotoList" style="width: 100%;"
                        :cell-style="{ padding: '0px' }">
                        <el-table-column type="index" label="No." width="60" header-align="center" align="center">
                        </el-table-column>
                        <el-table-column label="图片" width="220" header-align="center">
                            <template slot-scope="scope">
                                <el-image style="height: 100px" :src="scope.row.thumbnailPathUri"
                                    :preview-src-list="previewList(scope.row.thumbnailPathUri)"
                                    fit='contain'></el-image>
                            </template>
                        </el-table-column>
                        <el-table-column label="描述" width="475px" header-align="center">
                            <template slot-scope="scope">
                                <el-input type="textarea" rows="2"
                                    v-model="dataForm.closePhotoList[scope.$index].fileContent"
                                    placeholder="请填写"></el-input>
                            </template>
                        </el-table-column>
                        <el-table-column label=" " width="103" align="center">
                            <template slot-scope="scope">
                                <el-button size="mini" type="danger" @click="delClosePhoto(scope.$index)">删除</el-button>
                            </template>
                        </el-table-column>
                        <el-table-column label="同步" width="80" header-align="center" align="center">
                            <template slot-scope="scope">
                                <el-checkbox :value="scope.row.synchroFlg === 1"
                                    @change="(val) => (scope.row.synchroFlg = val ? 1 : 0)" class="sbox"
                                    label=""></el-checkbox>
                            </template>
                        </el-table-column>
                    </el-table>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="24" class="row-form-item">
                    <div class="fileItem">封闭时附件（如有时）</div>
                </el-col>
            </el-row>
            <el-row style="margin-top: 20px;">
                <el-col :span="8">
                    <el-upload ref="uploadFile" class="upload-demo" action="action" drag :http-request="uploadFile"
                        multiple :show-file-list=false :auto-upload="true">
                        <i class="el-icon-upload"></i>
                        <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                    </el-upload>
                </el-col>
                <el-col :span="16">
                    <el-table :data="dataForm.closeFileList" :cell-style="{ padding: '0px' }"
                        style="margin-bottom: 20px;" :show-header="false"
                        v-if="dataForm.closeFileList && dataForm.closeFileList.length > 0">
                        <el-table-column width="100" align="center" type="index">
                        </el-table-column>
                        <el-table-column prop="fileName" width="350" align="center">
                            <template slot-scope="scope">
                                <el-input class="sp-input" v-model="scope.row.fileName"></el-input>
                            </template>
                        </el-table-column>
                        <el-table-column width="150" align="center">
                            <template slot-scope="scope">
                                <el-button v-preventReClick type="text" size="small"
                                    @click="selectFile(scope.row.fileUri, scope.row.fileName)">查看</el-button>
                                <el-button v-preventReClick type="text" size="small"
                                    @click="delCloseFile(scope.$index)">删除</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                </el-col>
            </el-row>
        </el-row>
        <el-row class="formBtnGroup">
            <el-button v-preventReClick class="btn" type="primary" size="small"
                @click="dataFormSubmit()">确定封闭</el-button>
            <!-- <el-button v-preventReClick class="btn" type="primary" size="small" @click="cancelClose()">取消封闭</el-button> -->
            <el-button v-preventReClick class="btn" type="primary" size="small" @click="visible = false">取消</el-button>
        </el-row>
    </el-dialog>
</template>

<script>
import addImg from "@/assets/images/addImg.png"
import $common from "@/utils/common.js"
export default {
    name: "patrolList-Info",
    data() {
        return {
            title: '封闭',
            addImg: addImg,
            categoryList: [],
            sutConclusionList: [],
            testId: '',
            visible: true,
            showCloseItem: false,
            action: "",
            form: {},
            probCheck: '0',
            closeFlg: false,
            dataForm: {
                workNo: $common.getItem("workNo"),
                subjectNo: "",
                inspectionId: "",
                category: '',
                major: "",
                inspectionTime: "",
                inspectionPlace: "",
                inspectionMan: '',
                closeState: '',
                closeTime: '',
                closeMan: '',
                closeDescribe: '',
                photo: [],
                sutContent: '',
                scenePhotoList: [],
                closeFileList: [],
                closePhotoList: [],
                inspectionId: ''
            },
            dataRule: {
            }
        };
    },
    components: {

    },
    mounted() {
    },
    filters: {
        formatDate: function (value, args) {
            if (!value) {
                return ''
            }
            var dt = new Date(value);
            if (args == 'yyyy-M-d') {// yyyy-M-d
                let year = dt.getFullYear();
                let month = dt.getMonth() + 1;
                let date = dt.getDate();
                return `${year}-${month}-${date}`;
            } else if (args == 'yyyy-M-d H:m:s') {// yyyy-M-d H:m:s
                let year = dt.getFullYear();
                let month = dt.getMonth() + 1;
                let date = dt.getDate();
                let hour = dt.getHours();
                let minute = dt.getMinutes();
                let second = dt.getSeconds();
                return `${year}-${month}-${date} ${hour}:${minute}:${second}`;
            } else if (args == 'yyyy-MM-dd') {// yyyy-MM-dd
                let year = dt.getFullYear();
                let month = (dt.getMonth() + 1).toString().padStart(2, '0');
                let date = dt.getDate().toString().padStart(2, '0');
                return `${year}-${month}-${date}`;
            } else {// yyyy-MM-dd HH:mm:ss
                let year = dt.getFullYear();
                let month = (dt.getMonth() + 1).toString().padStart(2, '0');
                let date = dt.getDate().toString().padStart(2, '0');
                let hour = dt.getHours().toString().padStart(2, '0');
                let minute = dt.getMinutes().toString().padStart(2, '0');
                let second = dt.getSeconds().toString().padStart(2, '0');
                return `${year}-${month}-${date} ${hour}:${minute}:${second}`;
            }
        }
    },
    methods: {
        goBack() {
            this.$router.back()
        },
        init(id) {
            this.dataForm = {
                scenePhotoList: [],
                closeFileList: [],
                closePhotoList: [],
                inspectionId: this.inspectionId
            }
            this.getCategoryList();
            this.testId = id ? id : '';
            this.getDetail();
            this.$nextTick(() => {
                this.visible = true;
            });

        },
        selectFile(url, filename) {
            filename = this.getSuffix(url, filename)
            this.getBlob(url, (blob) => {
                this.saveAs(blob, filename)
            })
        },
        getSuffix(url, filename) {
            let lastIndex = url.lastIndexOf(".");
            return filename + url.substr(lastIndex)
        },
        getBlob(url, cb) {
            var xhr = new XMLHttpRequest()
            xhr.open('GET', url, true)
            xhr.responseType = 'blob'
            xhr.onload = function () {
                if (xhr.status === 200) {
                    cb(xhr.response)
                }
            }
            xhr.send()
        },
        saveAs(blob, filename) {
            if (window.navigator.msSaveOrOpenBlob) {
                navigator.msSaveBlob(blob, filename)
            }
            else {
                var link = document.createElement('a')
                var body = document.querySelector('body')

                link.href = window.URL.createObjectURL(blob)
                link.download = filename

                link.style.display = 'none'
                body.appendChild(link)

                link.click()
                body.removeChild(link)
                window.URL.revokeObjectURL(link.href)
            }
        },
        beforeUploadSituation(file) {
			const isValidType = file.type === 'image/jpeg' ||
				file.type === 'image/png' ||
				file.type === 'image/jpg'

			if (!isValidType) {
				this.$message.error('只能上传 JPG/PNG 格式的图片！')
				return false
			}
			return true
		},
        getDetail() {
            this.$http({
                url: this.$store.state.httpUrl + "/business/testrecord/info/" + this.testId,
                method: "get",
                params: {},
            }).then(({ data }) => {
                if (data && data.resultCode === 200) {
                    this.dataForm = data.body;
                    // 判断是否是有条件接受，是则展示封闭照片与文件模块
                    // if(this.dataForm.finalTestConclusion == '2') {
                    //     this.showCloseItem = true
                    // } else {
                    //     this.showCloseItem = false
                    // }
                }
            });
        },
        getCategoryList() {
            this.$http({
                url: this.$store.state.httpUrl + "/common/getCategoryList",
                method: "get",
                params: {},
            }).then(({ data }) => {
                if (data && data.resultCode === 200) {
                    this.categoryList = data.body;
                }
            });
        },
        getCategoryName(categoryId) {
            this.categoryList.forEach((item) => {
                if (categoryId === item.displayValue) {
                    return item.displayName
                }
            })
        },
        // 删除封闭相关文件
        delCloseFile(index) {
            let _closeFileList = this.dataForm.closeFileList;
            _closeFileList.splice(index, 1);
            this.dataForm.closeFileList = _closeFileList;
        },
        // 删除封闭相关图片
        delClosePhoto(index) {
            let _closePhotoList = this.dataForm.closePhotoList;
            _closePhotoList.splice(index, 1);
            this.dataForm.closePhotoList = _closePhotoList;
        },
        // 上传照片
        uploadImg(param) {
            const formData = new FormData();
            formData.append('file', param.file);
            this.$refs.uploadImg.clearFiles();
            this.$http.post(
                this.$store.state.httpUrl + "/file/upload/" + $common.getItem("workNo") + "/10/0",
                formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            },
            ).then(res => {
                res = res.data
                if (res.resultCode == 200) {
                    this.dataForm.closePhotoList.push({
                        testId: this.testId,
                        recFileType: '1',
                        fileName: res.body.fileName,
                        filePath: res.body.fileSavePath,
                        fileUri: res.body.fileUri,
                        fileContent: this.extractFileName(res.body.fileName),
                        thumbnailPath: res.body.thumbnailPath,
                        thumbnailPathUri: res.body.thumbnailPathUri,
                        compressedPath: res.body.compressedPath,
                        synchroFlg: '0'
                    });
                } else {
                    this.$message.info('文件上传失败')
                }
            })
        },
        // 上传文件
        uploadFile(param) {
            const formData = new FormData();
            formData.append('file', param.file);
            this.$refs.uploadFile.clearFiles();
            this.$http.post(
                this.$store.state.httpUrl + "/file/upload/" + $common.getItem("workNo") + "/10/0",
                formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            },
            ).then(res => {
                res = res.data
                if (res.resultCode == 200) {
                    this.dataForm.closeFileList.push({
                        testId: this.testId,
                        recFileType: '2',
                        fileName: this.extractFileName(res.body.fileName),
                        filePath: res.body.fileSavePath,
                        fileUri: res.body.fileUri
                    });
                } else {
                    this.$message.info('文件上传失败')
                }
            })
        },
        previewList(fileUri) {
            return [fileUri]
        },
        extractFileName(fileName) {
            let index = fileName.lastIndexOf(".");
            return fileName.substr(0, index)
        },
        dataFormSubmit() {
            if (this.closeFlg == false) {
                if (this.dataForm.closeTime == null || this.dataForm.closeTime == '') {
                    this.$message.error("请输入封闭时间！")
                    return;
                }
                if (this.dataForm.closeMan == null || this.dataForm.closeMan == '') {
                    this.$message.error("请输入封闭人！")
                    return;
                }
            }
            this.dataForm.testId = this.testId
            let _url = "/business/testrecord/closeTestRecord";
            this.$http({
                url: this.$store.state.httpUrl + _url,
                method: "post",
                data: this.$http.adornData({
                    testId: this.dataForm.testId,
                    closeTime: this.dataForm.closeTime,
                    closeMan: this.dataForm.closeMan,
                    closeDescribe: this.dataForm.closeDescribe,
                    remark: this.dataForm.remark,
                    scenePhotoList: this.dataForm.scenePhotoList,
                    closePhotoList: this.dataForm.closePhotoList,
                    closeFileList: this.dataForm.closeFileList,
                })
            }).then(({ data }) => {
                if (data && data.resultCode === 200) {
                    this.closeFlg = false
                    this.$message({
                        message: "操作成功",
                        type: "success",
                        duration: 1500,
                        onClose: () => {
                            this.visible = false;
                            // 数据更新成功后，触发事件通知父组件刷新数据
                            this.$emit('refreshDataList');
                        }
                    });
                }
            });
        },
        cancelClose() {
            this.$confirm(`确定要取消封闭吗？`, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$http({
                    url: this.$store.state.httpUrl + "/business/testrecord/cancelCloseTestRecord/" + this.dataForm.testId,
                    method: 'post',
                    params: {}
                }).then(({
                    data
                }) => {
                    if (data && data.resultCode === 200) {
                        this.$message({
                            message: '操作成功',
                            type: 'success',
                            duration: 1500,
                            onClose: () => {
                                this.visible = false;
                                // 数据更新成功后，触发事件通知父组件刷新数据
                                this.$emit('refreshDataList');
                            }
                        })
                    }
                })
            });
        }
    }
};
</script>

<style scoped="scoped">
/* 保留原有样式 */
.selItemInput.descAreaLg {
    width: 718px !important;
}

.selItemInput.descAreaLg1 {
    width: 918px !important;
}

.addImgBox {
    width: 180px;
    height: 180px;
    display: inline-block;
    vertical-align: middle;
    margin-right: 10px;
}

.upload-demo /deep/ .el-upload-dragger {
    width: 260px;
    height: 185px;
}

.upload-demo /deep/ .el-upload-dragger .el-icon-upload {
    font-size: 40px;
    margin: 0 0;
    line-height: 40px;
    padding-top: 45px
}

.upload-demo /deep/ .el-upload-dragger .el-upload__text {
    line-height: 20px;
}

.item::v-deep .el-form-item__label {
    color: #00428e !important;
    margin-right: 10px !important;
    font-weight: bold !important;
    align-items: center;
    background-color: #E1F1FF !important;
    border-right: 1px solid #dadada !important;
    white-space: normal;
    font-size: 12px !important;
    word-break: break-all;
}

::v-deep .el-form-item {
    display: flex !important;
    align-items: stretch !important;
    margin-bottom: 0px !important;
}

.item::v-deep .el-form-item__content {
    display: flex;
    align-items: center;
    white-space: normal;
    word-break: break-all;
    flex: 1;
    font-size: 12px !important;
    padding: 2px 0 !important;
    /* 减少内边距 */
    line-height: 1.4;
    /* 设置统一的行高 */
}

.fileItem::v-deep .el-form-item__label {
    text-align: right;
    padding-left: 20px;
    color: #00428e !important;
    font-weight: bold !important;
    width: 100% !important;
    min-height: 20px !important;
    display: flex;
    align-items: center;
}

.row-form-item {
    margin-top: 10px;
}

.row-form-item .el-form-item {
    margin-right: 0;
}

.border-form .el-row.set_border {
    border-bottom: 1px solid #dadada;
    border-left: 1px solid #dadada;
    border-right: 1px solid #dadada;
}

.border-form .el-row.set_border:first-child {
    border-top: 1px solid #dadada;
}

.border-form .el-row.set_border .col-set_border {
    border-right: 1px solid #dadada;
}

::v-deep .el-dialog__header {
    height: 60px;
    line-height: 30px;
}

.set_data {
    display: inline-block;
    line-height: 1.4;
    margin: 0 !important;
    padding: 2px 5px !important;
    min-height: 22px;
    font-size: 12px;
}

table {
    border-collapse: collapse;
    width: 100%;
}

th,
td {
    border: 1px solid #dadada;
    padding: 2px;
    text-align: center;
    font-size: 14px !important;
}

.ttd {
    background-color: #E1F1FF;
    width: 15%;
    text-align: right;
    padding: 8px 15px;
    color: #00428E !important;
    font-size: 12px;
    font-weight: bold;
}

.test-result-header {
    width: 12%;
}

.test-result-data {
    width: 12%;
}

.no-border-input /deep/ .el-input__inner {
    border-top: none !important;
    border-left: none !important;
    border-right: none !important;
    border-bottom: 1px solid #dcdfe6 !important;
    /* Element原生默认边框色 */
    border-radius: 0 !important;
    height: 32px !important;
    line-height: 32px !important;
    padding: 0 10px !important;
    box-shadow: none !important;
    outline: none !important;
}

/* textarea完全同规 - 原生默认+仅底部边框 */
.no-border-input /deep/ .el-textarea__inner {
    border-top: none !important;
    border-left: none !important;
    border-right: none !important;
    border-bottom: 1px solid #dcdfe6 !important;
    /* Element原生默认边框色 */
    border-radius: 0 !important;
    padding: 5px 10px !important;
    resize: none;
    box-shadow: none !important;
    outline: none !important;
}

/* 焦点状态 - 仅改Element原生主题色，不加粗、无阴影、无任何额外样式 */
.no-border-input /deep/ .el-input__inner:focus {
    border-top: none !important;
    border-left: none !important;
    border-right: none !important;
    border-bottom: 1px solid #409eff !important;
    /* Element原生焦点色，1px不变 */
    box-shadow: none !important;
    outline: none !important;
}

/* textarea焦点完全同规 - 仅改色，不加粗 */
.no-border-input /deep/ .el-textarea__inner:focus {
    border-top: none !important;
    border-left: none !important;
    border-right: none !important;
    border-bottom: 1px solid #409eff !important;
    /* Element原生焦点色，1px不变 */
    box-shadow: none !important;
    outline: none !important;
}



/* 隐藏日期选择器的图标 */
.no-border-input.el-date-editor.el-date-editor--date /deep/ .el-input__prefix {
    display: none !important;
}

.no-border-input.el-date-editor.el-date-editor--date /deep/ .el-input__inner {
    border: none !important;
    /* border-bottom: 1px solid #dcdfe6 !important; */
    border-radius: 0 !important;
    height: 32px !important;
    line-height: 32px !important;
    padding: 0 10px !important;
    /* 恢复正常内边距 */
    background-color: transparent !important;
}

::v-deep(.upload-demo-photo .el-upload-dragger) {
    width: 940px;
    height: 100px;
    margin-bottom: -30px;
}

::v-deep(.upload-demo-photo .el-upload-dragger .el-icon-upload) {
    font-size: 30px;
    margin: 20px 1px;
    line-height: 20px;
}

::v-deep(.upload-demo-photo .el-upload-dragger .el-upload__text) {
    line-height: 5px;
}
</style>